import { Component, attr } from '../Component'
import { element } from '../CustomElement'
import { i18n } from '../../i18n/I18n'

interface LoyaltyCardValidationProps extends JSX.HTMLProps {
    validationState: ValidationState
}

export type ValidationState = 'ok' | 'cardError' | 'phoneError' | 'pinError'

@element('flipp-loyalty-card-validation')
export class LoyaltyCardValidation extends Component<
    LoyaltyCardValidationProps,
    any
> {
    @attr validationState: ValidationState

    render() {
        return (
            <div>
                {this.validationState === 'cardError' ? (
                    <span>{i18n('add_card_invalid')}</span>
                ) : this.validationState === 'pinError' ? (
                    <span>{i18n('add_pin_invalid')}</span>
                ) : this.validationState === 'phoneError' ? (
                    <span>{i18n('add_phone_invalid')}</span>
                ) : null}
            </div>
        )
    }
}
